
import CookieBanner from '../components/lazyloads/dialogs/CookieBanner.vue'

export default {
  name: 'Landing',
  layout: 'layout-landing',
  components: {
    CookieBanner,
  },
}
